import { BrowserHistoryHandler } from '../../infrastructure/adapter/BrowserHistoryHandler';
import { ExperienceStateType, RoundPurposeType, TargetDeviceType } from '../../domain/entity/PortfolioReportItem';

export class HistoryHandlerUsecase {
  private browserHistoryHandler: BrowserHistoryHandler;

  constructor({ browserHistoryHandler }: { browserHistoryHandler: BrowserHistoryHandler }) {
    this.browserHistoryHandler = browserHistoryHandler;
  }

  public manipulateHistory(
    action: 'replace' | 'push',
    selectedOrganizationId: string,
    selectedGoalId: string,
    targetDeviceFilters: TargetDeviceType[],
    stateFilters: ExperienceStateType[],
    roundPurposeFilters: RoundPurposeType[],
  ) {
    let pathname = '';
    if (selectedOrganizationId) {
      pathname = `/organizations/${selectedOrganizationId}`;
    }
    if (selectedGoalId) {
      pathname += `?goalId=${selectedGoalId}`;
    }
    if (targetDeviceFilters.length > 0) {
      targetDeviceFilters.forEach(filter => {
        pathname += `&targetDevice=${filter}`;
      });
    }
    if (stateFilters.length > 0) {
      stateFilters.forEach(filter => {
        pathname += `&state=${filter}`;
      });
    }
    if (roundPurposeFilters.length > 0) {
      roundPurposeFilters.forEach(filter => {
        pathname += `&roundPurpose=${filter}`;
      });
    }
    if (action === 'replace') {
      this.browserHistoryHandler.replace(pathname);
    } else if (action === 'push') {
      this.browserHistoryHandler.push(pathname);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/application/usecase/HistoryHandlerUsecase.ts